// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   CharactersPage Styles
   ====================== */

.characters-page-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 32px 36px 0;
  overflow: hidden;
  box-sizing: border-box;
  background: var(--color-bg-root);
}

.characters-page-header-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.characters-page-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.characters-page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
  letter-spacing: -0.3px;
}

.characters-page-subtitle {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
}

.characters-page-new-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.characters-page-new-button:hover {
  opacity: 0.88;
}

/* Tabs */
.characters-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--color-border-input);
  flex-shrink: 0;
}

.characters-tab {
  padding: 8px 16px;
  border: none;
  background: none;
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.characters-tab:hover {
  color: var(--color-text-primary);
}

.characters-tab.active {
  color: var(--color-text-primary);
  border-bottom-color: var(--color-text-primary);
}

/* Library layout — sidebar + main */
.characters-library-layout {
  display: flex;
  gap: 0;
  flex: 1 1;
  min-height: 0;
}

.characters-sidebar {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 24px;
  margin-right: 24px;
  border-right: 1px solid var(--color-border-input);
  overflow-y: auto;
  padding-bottom: 24px;
}

.characters-sidebar-search {
  width: 100%;
  padding: 8px 11px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}

.characters-sidebar-search:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.characters-sidebar-search::placeholder {
  color: var(--color-text-secondary);
}

.characters-library-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 32px;
}

/* Filter groups */
.characters-filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.characters-filter-group-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  opacity: 0.6;
}

.characters-filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.characters-filter-chip {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  user-select: none;
  -webkit-user-select: none;
}

.characters-filter-chip:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.characters-filter-chip.active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

.characters-filter-chip.active:hover {
  opacity: 0.88;
}

/* Active filter pills shown above grid */
.characters-filter-active {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-bottom: 16px;
}

.characters-filter-clear {
  width: 100%;
  padding: 6px 0;
  border: none;
  background: none;
  color: var(--color-text-secondary);
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s ease, color 0.15s ease;
  text-align: left;
}

.characters-filter-clear:hover {
  color: var(--color-text-primary);
  opacity: 1;
}

/* My Characters layout */
.characters-my-layout {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.characters-my-search-sticky {
  flex-shrink: 0;
  margin-bottom: 16px;
}

.characters-my-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 32px;
}

/* Search */
.characters-page-search-row {
  margin-bottom: 16px;
}

.characters-page-search {
  width: 100%;
  max-width: 340px;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}

.characters-page-search:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.characters-page-search::placeholder {
  color: var(--color-text-secondary);
}

/* Error */
.characters-page-error {
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: rgba(220, 38, 38, 0.08);
  color: #dc2626;
  font-size: 13px;
  margin-bottom: 16px;
}

/* Loading */
.characters-page-loading {
  color: var(--color-text-secondary);
  font-size: 13px;
  padding: 40px 0;
  text-align: center;
}

/* Empty state */
.characters-page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 80px 24px;
  text-align: center;
  color: var(--color-text-secondary);
}

.characters-page-empty-icon {
  opacity: 0.3;
  margin-bottom: 4px;
}

.characters-page-empty p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.characters-page-empty-hint {
  font-size: 13px !important;
  font-weight: 400 !important;
  opacity: 0.7;
}

.characters-page-empty-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 9px 16px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.characters-page-empty-cta:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* Grid */
.characters-page-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

/* Character card — large vertical */
.character-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-sidebar);
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.character-card:hover {
  border-color: var(--color-text-secondary);
  transform: translateY(-2px);
}

.character-card:focus {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 1px;
}

/* Image area — 80% of card height */
.character-card-image {
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  background: var(--color-bg-canvas-surface);
  flex-shrink: 0;
}

.character-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.character-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: 700;
  color: var(--color-text-secondary);
  opacity: 0.4;
}

/* Info area — bottom 20% */
.character-card-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  min-width: 0;
}

.character-card-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.character-card-description {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Create modal */
.character-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.character-modal {
  background: var(--color-bg-sidebar);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.character-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0 0 20px;
}

.character-modal-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
  margin-bottom: 16px;
}

.character-modal-input,
.character-modal-textarea {
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}

.character-modal-input:focus,
.character-modal-textarea:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.character-modal-textarea {
  resize: vertical;
  min-height: 80px;
}

.character-modal-error {
  padding: 8px 12px;
  border-radius: 4px;
  background: rgba(220, 38, 38, 0.08);
  color: #dc2626;
  font-size: 12px;
  margin-bottom: 16px;
}

.character-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.character-modal-cancel {
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.character-modal-cancel:hover {
  background: var(--color-bg-input);
}

.character-modal-submit {
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.character-modal-submit:hover:not(:disabled) {
  opacity: 0.88;
}

.character-modal-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/CharactersPage.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,MAAM;EACN,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* ======================\n   CharactersPage Styles\n   ====================== */\n\n.characters-page-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  padding: 32px 36px 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  background: var(--color-bg-root);\n}\n\n.characters-page-header-section {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.characters-page-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.characters-page-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.characters-page-subtitle {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.characters-page-new-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.characters-page-new-button:hover {\n  opacity: 0.88;\n}\n\n/* Tabs */\n.characters-tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: 20px;\n  border-bottom: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n}\n\n.characters-tab {\n  padding: 8px 16px;\n  border: none;\n  background: none;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.characters-tab:hover {\n  color: var(--color-text-primary);\n}\n\n.characters-tab.active {\n  color: var(--color-text-primary);\n  border-bottom-color: var(--color-text-primary);\n}\n\n/* Library layout — sidebar + main */\n.characters-library-layout {\n  display: flex;\n  gap: 0;\n  flex: 1;\n  min-height: 0;\n}\n\n.characters-sidebar {\n  width: 220px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-right: 24px;\n  margin-right: 24px;\n  border-right: 1px solid var(--color-border-input);\n  overflow-y: auto;\n  padding-bottom: 24px;\n}\n\n.characters-sidebar-search {\n  width: 100%;\n  padding: 8px 11px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease;\n}\n\n.characters-sidebar-search:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.characters-sidebar-search::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.characters-library-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding-bottom: 32px;\n}\n\n/* Filter groups */\n.characters-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.characters-filter-group-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  opacity: 0.6;\n}\n\n.characters-filter-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.characters-filter-chip {\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.characters-filter-chip:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.characters-filter-chip.active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);\n}\n\n.characters-filter-chip.active:hover {\n  opacity: 0.88;\n}\n\n/* Active filter pills shown above grid */\n.characters-filter-active {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.characters-filter-clear {\n  width: 100%;\n  padding: 6px 0;\n  border: none;\n  background: none;\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  opacity: 0.6;\n  transition: opacity 0.15s ease, color 0.15s ease;\n  text-align: left;\n}\n\n.characters-filter-clear:hover {\n  color: var(--color-text-primary);\n  opacity: 1;\n}\n\n/* My Characters layout */\n.characters-my-layout {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.characters-my-search-sticky {\n  flex-shrink: 0;\n  margin-bottom: 16px;\n}\n\n.characters-my-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 32px;\n}\n\n/* Search */\n.characters-page-search-row {\n  margin-bottom: 16px;\n}\n\n.characters-page-search {\n  width: 100%;\n  max-width: 340px;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease;\n}\n\n.characters-page-search:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.characters-page-search::placeholder {\n  color: var(--color-text-secondary);\n}\n\n/* Error */\n.characters-page-error {\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: rgba(220, 38, 38, 0.08);\n  color: #dc2626;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n/* Loading */\n.characters-page-loading {\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  padding: 40px 0;\n  text-align: center;\n}\n\n/* Empty state */\n.characters-page-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 80px 24px;\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.characters-page-empty-icon {\n  opacity: 0.3;\n  margin-bottom: 4px;\n}\n\n.characters-page-empty p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.characters-page-empty-hint {\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  opacity: 0.7;\n}\n\n.characters-page-empty-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 9px 16px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.characters-page-empty-cta:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* Grid */\n.characters-page-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n/* Character card — large vertical */\n.character-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-sidebar);\n  cursor: pointer;\n  overflow: hidden;\n  transition: border-color 0.15s ease, transform 0.15s ease;\n}\n\n.character-card:hover {\n  border-color: var(--color-text-secondary);\n  transform: translateY(-2px);\n}\n\n.character-card:focus {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 1px;\n}\n\n/* Image area — 80% of card height */\n.character-card-image {\n  width: 100%;\n  aspect-ratio: 3 / 4;\n  overflow: hidden;\n  background: var(--color-bg-canvas-surface);\n  flex-shrink: 0;\n}\n\n.character-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.character-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 48px;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  opacity: 0.4;\n}\n\n/* Info area — bottom 20% */\n.character-card-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 14px;\n  min-width: 0;\n}\n\n.character-card-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.character-card-description {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Create modal */\n.character-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.character-modal {\n  background: var(--color-bg-sidebar);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 24px;\n  width: 100%;\n  max-width: 440px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.character-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin: 0 0 20px;\n}\n\n.character-modal-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  margin-bottom: 16px;\n}\n\n.character-modal-input,\n.character-modal-textarea {\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease;\n}\n\n.character-modal-input:focus,\n.character-modal-textarea:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.character-modal-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.character-modal-error {\n  padding: 8px 12px;\n  border-radius: 4px;\n  background: rgba(220, 38, 38, 0.08);\n  color: #dc2626;\n  font-size: 12px;\n  margin-bottom: 16px;\n}\n\n.character-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.character-modal-cancel {\n  padding: 8px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.character-modal-cancel:hover {\n  background: var(--color-bg-input);\n}\n\n.character-modal-submit {\n  padding: 8px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.character-modal-submit:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.character-modal-submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
